<template>
    <div class="weather-chart-main">
        <div class="content">

            <div v-if="isloadedstat == 0">
                <loading-button/>
            </div>

            <embed type="application/pdf"
                   :src="getPdfStreamUrl"
                   @load="isloaded(1)"
                   @onloadstart="isloaded(0)"
                   width="100%" height="100%" alt="pdf"
                   background-color="0xFF525659" top-toolbar-height="56" full-frame=""
                   internalinstanceid="21"
                   title="CHROME">
        </div>
    </div>
</template>

<script>
    import {loadingMixin} from "../../../../utils/mixins";
    import {mapState} from "vuex";
    //import {createUrl} from "../../http";
    import {createUrl} from "../../../../http";
    import LoadingButton from "../../../../components/ui/LoadingButton";
    export default {
        name: "WeatherCharts",
        mixins: [loadingMixin],
        props: ["id", "flight"],

        data(){
            return{
                // last folderdan otomatik çekecek şekilde al...
                weatherChartUrl:createUrl('/EffIpadPreview/GetLastWeatherChartPdf/'), //"https://localhost:44333/api/EffIpadPreview/GetLastWeatherChartPdf/", //createUrl('/EffIpadPreview/GetLastWeatherChartPdf/'),  // "https://localhost:44333/api/EffIpadPreview/GetLastWeatherChartPdf/"
                isloadedstat:0,
            }
        },

        components: {
            LoadingButton,
        },

        methods:{

            isloaded(stat){

                this.isloadedstat = stat;

            }

        },

        computed: {
            ...mapState("ipadmain",[/*"FKey1",*/ "selectedFlightItems","OCCSelfVersions_VS_IPADLastKnownVersions","OCCVers_IPADVers_LastIndex"]),

            getPdfStreamUrl:{
                get(){
                    return this.weatherChartUrl + this.flight.fKeyForZip + '/'  + this.flight.std+'/'+this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].wlvt;
                },
                set()
                {

                }

            },

            Comprendercomponentstat :
                {
                    get()
                    {
                        if(this.isActiveAttachmentModal == true)
                        {
                            return 1;
                        }
                        else
                        {
                            return 0;
                        }
                    }
                }



        },


        created() {

        }
    }
</script>

<style scoped>
    .content{
        width: 100%;
        height: 900px;
    }

</style>
